import React from 'react'
import { CookieConsentUserSettingsPage } from './CookieConsentUserSettingsPage'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const CookieConsentUserSettingsPageRegistration = createRegisterableComponent(
    'cookie-consent-user-settings-page',
    () => <CookieConsentUserSettingsPage />
)
